import { Autocomplete, Grid, TextField } from "@mui/material"
import { ClasseSocialKeys, IClasseSocial } from "../../../../../../../application/models"
import { classeSocialKeyToLabel } from "../../../detalhes-do-projeto/filtros/classe-social"
import { useState, useEffect } from "react"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useUIService } from "../../../../../../../use-cases/ui"
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteClasseSocial = () => {
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    const [selectedClasseSocial, setSelectedClasseSocial] = useState<IClasseSocial[]>([])
    const { syncFilterWithForm, removeFilterFromForm, resetSelectedFilter } = useRecortesExtracaoService()
    const { setAlert } = useUIService()

    useEffect(() => {
        const classesSelecionadas = createRecorteExtracaoForm.fields.Filtros?.classeSocial || [];

        if (classesSelecionadas.length > 0) {
            setSelectedClasseSocial(classesSelecionadas);
        } else {
            setSelectedClasseSocial([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.classeSocial]);

    const filteredClasseSocial = ClasseSocialKeys.filter((classeSocial: IClasseSocial) =>
        !selectedClasseSocial.some((selected: IClasseSocial) => selected === classeSocial)
    );

    const handleClasseSocialSelectionChange = (value: IClasseSocial[]) => {
        setSelectedClasseSocial(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'classeSocial',
                value: value,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'classeSocial',
                formType: 'create'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredClasseSocial}
                    getOptionLabel={(option) => classeSocialKeyToLabel(option).toUpperCase()}
                    sx={{ px: 2 }}
                    value={selectedClasseSocial}
                    onChange={(event, value) => {
                        handleClasseSocialSelectionChange(value);
                    }}
                    noOptionsText='Nenhuma classe social encontrada'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de Classes Sociais"
                        />
                    )}
                />
            </Grid>
        </>
    )
}